module.exports = __webpack_public_path__ + "img/tag_plus.d74a9d98.png";